"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var adminAuth_1 = require("./adminAuth");
var linksStorage_1 = require("./linksStorage");
var Links_less_1 = __importDefault(require("./Links.less"));
var Links = function () {
    var _a = (0, react_1.useState)(function () { return (0, linksStorage_1.loadLinks)(); }), links = _a[0], setLinks = _a[1];
    var _b = (0, react_1.useState)(null), selectedId = _b[0], setSelectedId = _b[1];
    var _c = (0, react_1.useState)(function () { return (0, adminAuth_1.isAdminUnlocked)(); }), admin = _c[0], setAdmin = _c[1];
    var _d = (0, react_1.useState)(false), showAdminForm = _d[0], setShowAdminForm = _d[1];
    var _e = (0, react_1.useState)(''), pin = _e[0], setPin = _e[1];
    var _f = (0, react_1.useState)(''), title = _f[0], setTitle = _f[1];
    var _g = (0, react_1.useState)(''), url = _g[0], setUrl = _g[1];
    var _h = (0, react_1.useState)(null), editingId = _h[0], setEditingId = _h[1];
    var _j = (0, react_1.useState)(null), error = _j[0], setError = _j[1];
    var selected = (0, react_1.useMemo)(function () { var _a; return (_a = links.find(function (link) { return link.id === selectedId; })) !== null && _a !== void 0 ? _a : null; }, [links, selectedId]);
    var refresh = (0, react_1.useCallback)(function () {
        var next = (0, linksStorage_1.loadLinks)();
        setLinks(next);
        setSelectedId(function (current) {
            var _a, _b;
            if (current && next.some(function (link) { return link.id === current; })) {
                return current;
            }
            return (_b = (_a = next[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
        });
    }, []);
    (0, react_1.useEffect)(function () {
        refresh();
    }, [refresh]);
    var onUnlock = (0, react_1.useCallback)(function () {
        setError(null);
        if (!(0, adminAuth_1.unlockAdmin)(pin)) {
            setError('Wrong admin PIN');
            return;
        }
        setAdmin(true);
        setPin('');
        setShowAdminForm(true);
    }, [pin]);
    var onLock = (0, react_1.useCallback)(function () {
        (0, adminAuth_1.lockAdmin)();
        setAdmin(false);
        setShowAdminForm(false);
        setEditingId(null);
        setTitle('');
        setUrl('');
        setError(null);
    }, []);
    var onStartEdit = (0, react_1.useCallback)(function (link) {
        setEditingId(link.id);
        setTitle(link.title);
        setUrl(link.url);
        setShowAdminForm(true);
        setError(null);
    }, []);
    var onCancelEdit = (0, react_1.useCallback)(function () {
        setEditingId(null);
        setTitle('');
        setUrl('');
        setError(null);
    }, []);
    var onSave = (0, react_1.useCallback)(function () {
        setError(null);
        try {
            var saved = (0, linksStorage_1.saveLink)({
                id: editingId !== null && editingId !== void 0 ? editingId : undefined,
                title: title,
                url: url,
            });
            refresh();
            setSelectedId(saved.id);
            onCancelEdit();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Could not save link');
        }
    }, [editingId, title, url, refresh, onCancelEdit]);
    var onDelete = (0, react_1.useCallback)(function (id) {
        (0, linksStorage_1.removeLink)(id);
        if (editingId === id) {
            onCancelEdit();
        }
        refresh();
    }, [editingId, onCancelEdit, refresh]);
    return (react_1.default.createElement(components_1.MainNavBars, { className: Links_less_1.default['links-container'], route: 'links' },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Links_less_1.default['links-content'], 'animation-fade-in') },
            react_1.default.createElement("div", { className: Links_less_1.default['header-row'] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: Links_less_1.default['title'] }, "Links"),
                    react_1.default.createElement("div", { className: Links_less_1.default['subtitle'] }, "Saved YouTube videos and channels \u2014 plays via official youtube.com/embed only")),
                react_1.default.createElement("div", { className: Links_less_1.default['admin-actions'] }, admin ?
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Links_less_1.default['action-button'], Links_less_1.default['accent']), title: 'Add link', onClick: function () {
                                onCancelEdit();
                                setShowAdminForm(true);
                            } },
                            react_1.default.createElement(react_2.default, { className: Links_less_1.default['action-icon'], name: 'add' }),
                            "Add"),
                        react_1.default.createElement(components_1.Button, { className: Links_less_1.default['action-button'], title: 'Lock admin', onClick: onLock }, "Lock admin"))
                    :
                        react_1.default.createElement(components_1.Button, { className: Links_less_1.default['action-button'], title: 'Admin', onClick: function () {
                                setShowAdminForm(function (open) { return !open; });
                                setError(null);
                            } }, "Admin"))),
            showAdminForm && !admin ?
                react_1.default.createElement("div", { className: Links_less_1.default['admin-panel'] },
                    react_1.default.createElement("div", { className: Links_less_1.default['admin-panel-title'] }, "Admin unlock"),
                    react_1.default.createElement("div", { className: Links_less_1.default['admin-hint'] }, "Enter the local PIN (default in code: see adminAuth.ts). Not production auth."),
                    react_1.default.createElement("div", { className: Links_less_1.default['form-row'] },
                        react_1.default.createElement(components_1.TextInput, { className: Links_less_1.default['text-input'], type: 'password', placeholder: 'PIN', value: pin, onChange: function (event) { return setPin(event.currentTarget.value); }, onSubmit: onUnlock }),
                        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Links_less_1.default['action-button'], Links_less_1.default['accent']), onClick: onUnlock }, "Unlock")),
                    error ? react_1.default.createElement("div", { className: Links_less_1.default['error'] }, error) : null)
                :
                    null,
            admin && showAdminForm ?
                react_1.default.createElement("div", { className: Links_less_1.default['admin-panel'] },
                    react_1.default.createElement("div", { className: Links_less_1.default['admin-panel-title'] }, editingId ? 'Edit link' : 'Add YouTube link'),
                    react_1.default.createElement("div", { className: Links_less_1.default['admin-hint'] }, "Paste a youtube.com / youtu.be video, playlist, /channel/UC\u2026, or /user/\u2026 URL. @handle URLs need a /channel/UC\u2026 link for embed playback."),
                    react_1.default.createElement("div", { className: Links_less_1.default['form-row'] },
                        react_1.default.createElement(components_1.TextInput, { className: Links_less_1.default['text-input'], placeholder: 'Title (optional)', value: title, onChange: function (event) { return setTitle(event.currentTarget.value); } }),
                        react_1.default.createElement(components_1.TextInput, { className: Links_less_1.default['text-input'], placeholder: 'https://www.youtube.com/watch?v=…', value: url, onChange: function (event) { return setUrl(event.currentTarget.value); }, onSubmit: onSave }),
                        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Links_less_1.default['action-button'], Links_less_1.default['accent']), onClick: onSave }, "Save"),
                        react_1.default.createElement(components_1.Button, { className: Links_less_1.default['action-button'], onClick: onCancelEdit }, "Clear")),
                    error ? react_1.default.createElement("div", { className: Links_less_1.default['error'] }, error) : null)
                :
                    null,
            react_1.default.createElement("div", { className: Links_less_1.default['body'] },
                react_1.default.createElement("div", { className: Links_less_1.default['list-pane'] }, links.length === 0 ?
                    react_1.default.createElement("div", { className: Links_less_1.default['empty'] }, "No saved links yet. Unlock Admin to paste a YouTube URL.")
                    :
                        links.map(function (link) {
                            var _a;
                            return (react_1.default.createElement("div", { key: link.id, className: (0, classnames_1.default)(Links_less_1.default['link-card'], (_a = {},
                                    _a[Links_less_1.default['selected']] = link.id === selectedId,
                                    _a)), role: 'button', tabIndex: 0, title: link.title, onClick: function () { return setSelectedId(link.id); }, onKeyDown: function (event) {
                                    if (event.key === 'Enter') {
                                        setSelectedId(link.id);
                                    }
                                } },
                                react_1.default.createElement("div", { className: Links_less_1.default['link-card-title'] }, link.title),
                                react_1.default.createElement("div", { className: Links_less_1.default['link-card-meta'] },
                                    link.kind,
                                    " \u00B7 ",
                                    link.url),
                                admin ?
                                    react_1.default.createElement("div", { className: Links_less_1.default['link-card-actions'] },
                                        react_1.default.createElement(components_1.Button, { className: Links_less_1.default['mini-button'], title: 'Edit', onClick: function (event) {
                                                event.stopPropagation();
                                                onStartEdit(link);
                                            } }, "Edit"),
                                        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Links_less_1.default['mini-button'], Links_less_1.default['danger']), title: 'Remove', onClick: function (event) {
                                                event.stopPropagation();
                                                onDelete(link.id);
                                            } }, "Remove"))
                                    :
                                        null));
                        })),
                react_1.default.createElement("div", { className: Links_less_1.default['player-pane'] }, selected ?
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: Links_less_1.default['player-title'] }, selected.title),
                        react_1.default.createElement("div", { className: Links_less_1.default['player-frame-wrap'] },
                            react_1.default.createElement("iframe", { className: Links_less_1.default['player-frame'], title: selected.title, src: selected.embedUrl, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', allowFullScreen: true, referrerPolicy: 'strict-origin-when-cross-origin' })))
                    :
                        react_1.default.createElement("div", { className: Links_less_1.default['player-placeholder'] }, "Select a link to play it in the official YouTube embed."))))));
};
exports.default = Links;
